// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

// Import utilities
const {
	debounce,
	isDefined,
	isEmpty
} = _uo.utility;

import {
	AJAXRequest,
	getCurrentFieldsValues,
	getField,
} from '@builder/common/utilities';

import Field from './index.js';

const sortable = require( 'html5sortable' );

class FieldsRepeater {
	// eslint-disable-next-line no-unused-vars
	constructor( attributes, createDOMelements = true, customValidationFunction = null ) {
		// Save attributes
		this.setAttributes( attributes );

		// Create fields
		this.createFields();

		window.test = this;
	}

	/**
	 * Set attributes. It add properties like hasValue, hasPlaceholder, etc, automatically
	 *
	 * @since 0.4
	 * @param {object} attributes - The field attributes
	 * @return {object} attributes - The field attributes
	 */
	setAttributes( attributes ) {
		// Has label
		if ( ! isDefined( attributes.hasLabel ) ) {
			if ( ! isEmpty( attributes.label ) ) {
				attributes.hasLabel = true;
			} else {
				attributes.hasLabel = false;
			}
		}

		// Has description
		if ( ! isDefined( attributes.hasDescription ) ) {
			if ( ! isEmpty( attributes.description ) ) {
				attributes.hasDescription = true;
			} else {
				attributes.hasDescription = false;
			}
		}

		// Default token name
		if ( isEmpty( attributes.tokenName ) ) {
			attributes.tokenName = attributes.label;
		}

		// Check if we should sort the rows
		if ( ! isDefined( attributes.canSortRows ) ) {
			attributes.canSortRows = true;
		}

		this.attributes = attributes;
	}

	/**
	 * Create instances of Field
	 *
	 * @since  2.0
	 * @return undefined
	 */
	createFields() {
		// Get fields template
		const rowFieldsTemplate = this.attributes.fields;

		// Create array with fields
		let fieldsRows = [];

		// Check if there is data and create multiple rows of the repeater field
		if ( Array.isArray( this.attributes.currentValue ) && this.attributes.currentValue.length > 0 ) {
			// https://regex101.com/r/tLL7S9/1/
			// Get field id and index from strings like FIELD_1

			// Iterate default rows
			this.attributes.currentValue.forEach( ( row ) => {
				// Clone template row
				let rowFields = JSON.parse( JSON.stringify( rowFieldsTemplate ) );

				// Iterate the rows in the template and try to get their
				// value from the "row" array
				rowFields = rowFields.map( ( field ) => {
					// Check if there is a value for this field
					if ( isDefined( row[ field.optionCode ] ) ) {
						// Save value
						field.currentValue = row[ field.optionCode ];

						// Check if there is a custom value and if we should add it
						if ( 
							field.currentValue == 'automator_custom_value' && 
							isDefined( row[ `${ field.optionCode }_custom` ] )
						) {
							field.customValue = row[ `${ field.optionCode }_custom` ];
						}
					} else {
						// Set empty value
						field.currentValue = '';
					}

					// Return field
					return field;
				} );

				// Add row with fields
				fieldsRows.push( rowFields );
			} );
		} else if ( this.attributes.isRequired ) {
			// Otherwise, just create one row
			// Check if the field is required
			//
			// Create an empty row
			const emptyRow = JSON.parse( JSON.stringify( rowFieldsTemplate ) );

			// Remove undefined current value
			emptyRow.currentValue = '';

			// Add it to the main array
			fieldsRows.push( emptyRow );
		}

		// Now iterate the row with fields
		fieldsRows = fieldsRows.map( ( row ) => {
			// Now iterate each group of fields
			row = row.map( ( fieldObject ) => {
				// Remove the label
				// fieldObject.label = '';

				// Remove the description
				fieldObject.description = '';

				// Add item ID
				fieldObject.itemId = this.attributes.itemId;

				// Create field
				const field = new Field( fieldObject.fieldType, fieldObject );

				// AJAX: Check if it's the mapping column
				field.isMappingColumn = isDefined( this.attributes.ajax ) && 
                                        isDefined( this.attributes.ajax.mappingColumn ) && 
                                        field.getFieldID() === this.attributes.ajax.mappingColumn;

				// Return field instance
				return field;
			} );

			// Return row
			return row;
		} );

		// Update the fields property
		this.fieldRows = fieldsRows;
	}

	/**
	 * Create a jQuery DOM element with the field
	 *
	 * @since 0.3
	 */
	createFormElement() {
		// Create response object
		let response = null;

		// Create container
		const $container = $( `<div class="form-repeater"></div>` );

		// Check if it has a label
		if ( this.attributes.hasLabel ) {
			// Create label
			const $label = $( `
				<div class="form-repeater__label">
					${ this.attributes.label }
					${ this.attributes.isRequired ? `<span class="form-repeater__label-required"></span>` : `` }
				</div>
			` );

			// Add button to manually trigger AJAX call again
			if (
				isDefined( this.attributes.ajax ) && 
				isDefined( this.attributes.ajax.event ) && 
				[ 'parent_fields_change', 'on_load' ].includes( this.attributes.ajax.event )
			) {
				$label.get(0).insertAdjacentHTML( 'beforeEnd', `
					<uo-button
						color="secondary"
						size="extra-small"
						class="form-element-ajax-refresh-btn"
					>
						<uo-icon id="sync"></uo-icon>

						${ UncannyAutomator.i18n.refresh }
					</uo-button>
				` );
			}

			// Append label
			$container.append( $label );
		}

		// Create table with the fields
		const $table = this.getFieldsTable();
		$container.append( $table );

		// Add error container
		$table.append( $( `<div class="form-element__error"></div>` ) );

		// Check if it has a description
		if ( this.attributes.hasDescription ) {
			// Create description
			const $description = $( `<div class="form-repeater__description">${ this.attributes.description }</div>` );

			// Append description
			$container.append( $description );
		}

		// Save form element
		this.formElement = $container;
		response = $container;

		// If there is more than one row, make list sortable
		if ( this.fieldRows.length > 1 ) {
			this.makeRowsSortable();
		}

		// Listen save
		this.listenSave();

		// Listen fields for AJAX
		this.handleAJAX();

		// Return form element
		return response;
	}

	/**
	 * Gets the data needed by the server when doing AJAX requests from the field
	 * 
	 * @param {Object} options 
	 * @param {String} options.fieldToListenToCode The ID of the field that triggered the AJAX call
	 * @returns {Object} The data to be sent to the server when doing an AJAX call made by the field
	 */
	getAjaxRequestData( { fieldToListenToCode } ) { 
		return {
			recipe_id: UncannyAutomator.recipe.id,
			item_id: this.attributes.itemId,
			group_id: this.attributes.groupId,
			field_id: this.attributes.optionCode,
			triggered_by: fieldToListenToCode,
			values: getCurrentFieldsValues( { itemID: this.attributes.itemId, field: this } ),
		}
	}

	/**
	 * Merges two objects with fields data, keeping values as much as possible, assuming the values in the
	 * mapping column are unique
	 * 
	 * 
	 */
	getMergedValuesWithMappingColumn( oldValues, newValues ) {
		if ( ! isDefined( this.attributes.ajax.mappingColumn ) ) {
			return;
		}

		// Map old rows using the mapping column
		const oldRowsMappingColumn = {}

		oldValues.forEach( row => {
			const mappingValue = row[ this.attributes.ajax.mappingColumn ];

			// Check if the mapping column has a value
			if ( isEmpty( mappingValue ) ) {
				return;
			}

			delete row[ this.attributes.ajax.mappingColumn ];
			oldRowsMappingColumn[ mappingValue ] = row;
		} );
		
		newValues = newValues.map( ( row ) => {
			// Try to get the old values
			const oldValues = isDefined( oldRowsMappingColumn[ row[ this.attributes.ajax.mappingColumn ] ] ) ? oldRowsMappingColumn[ row[ this.attributes.ajax.mappingColumn ] ] : {};

			return { ...row, ...oldValues };
		} );

		return newValues;
	}

	/**
	 * Returns the mapping column that's used to update the field
	 */
	get ajaxMappingColumn() {
		if ( ! isDefined( this.attributes.ajax ) ) {
			return;
		}

		if ( ! isDefined( this.attributes.ajax.mappingColumn ) ) {
			return;
		}
		
		return this.attributes.ajax.mappingColumn;
	}

	/**
	 * Handles the AJAX functionality on fields
	 * Fields will listen to changes on other fields and trigger an AJAX call to retrieve a value or dropdown options
	 */
	handleAJAX() {
		// Check if we should listen to other fields
		if ( ! isDefined( this.attributes.ajax ) || ! isDefined( this.attributes.ajax.event ) || ! isDefined( this.attributes.ajax.mappingColumn ) ) {
			return;
		}

		/**
		 * Performs the AJAX call
		 */
		const doAJAX = ( { fieldToListenToCode = '', onSuccess = () => {} } ) => {
			// Save the old values
			const oldRows = this.getValue( { includeReadOnly: false } );

			// Before starting, clear any errors
			// This will hide errors from previous calls before doing the new one
			this.clearError();

			AJAXRequest(
				this.attributes.ajax.endpoint,
				this.getAjaxRequestData( { fieldToListenToCode } ),
				( response ) => {
					// We'll update this even if the call returns an error. The call itself was successful
					this.attributes.ajax.firstLoadDone = true;

					try {
						onSuccess();
					} catch ( e ) {}
					
					// Check if the call was successful
					if ( isDefined( response.success ) && ! response.success ) {
						// Reset value
						this.setValue( [] );

						// Check if there is a message available
						if ( ! isEmpty( response.error ) ) {
							this.setError( response.error );
						}

						return;
					}

					// Set rows, but try to keep the previous values
					this.setValue( this.getMergedValuesWithMappingColumn( oldRows, response.rows ) );
				}
			);
		}

		// Check if we have to listen other fields
		if ( this.attributes.ajax.event === 'parent_fields_change' ) {
			// Parent change event
			const parentChangeEvent = `automator:field:change.handle-ajax-${ this.attributes.optionCode }`;

			// Check if the fields exist
			if ( ! isDefined( this.attributes.ajax.listenFields ) && Array.isArray( this.attributes.ajax.listenFields ) ) {
				return;
			}

			this.attributes.ajax.listenFields.forEach( ( fieldID ) => {
				// Get field
				const fieldToListenTo = getField( this.attributes.itemId, fieldID );

				// Get the debounce delay based on the field type
				const debounceDelay = [ 'date', 'time', 'select', 'radio', 'checkbox' ].includes( fieldToListenTo.type ) ? 0 : 1000;

				// Listen changes to the parent field
				fieldToListenTo.formElement.off( parentChangeEvent );
				fieldToListenTo.formElement.on( parentChangeEvent, debounce( ( event, context ) => {
					// Don't trigger when getting formElement
					if ( isDefined( context ) && isDefined( context.source ) && context.source === 'getFormElement' ) {
						return;
					} 

					// Before doing the request, show a loading animation in the field that changed
					fieldToListenTo.startLoadingAnimation();
					// And show animation in the target field too
					this.startLoadingAnimation();

					doAJAX( {
						fieldToListenToCode: fieldToListenTo.attributes.optionCode,
						onSuccess: () => {
							// Stop loading animation in both fields
							fieldToListenTo.stopLoadingAnimation();
							this.stopLoadingAnimation();
						}
					} );
				}, debounceDelay ) );

				// Check if it's a dropdown that supports custom values
				if ( fieldToListenTo.type === 'select' && fieldToListenTo.attributes.supportsCustomValue ) {
					fieldToListenTo.customValueField.formElement.off( parentChangeEvent );
					fieldToListenTo.customValueField.formElement.on( 'automator:field:change', debounce( ( event, context ) => {
						// Don't trigger when getting formElement
						if ( isDefined( context ) && isDefined( context.source ) && context.source === 'getFormElement' ) {
							return;
						}

						// Before doing the request, show a loading animation in the field that changed
						fieldToListenTo.startLoadingAnimation();
						// Show loading animation in the custom value too
						fieldToListenTo.customValueField.startLoadingAnimation();
						// And show animation in the target field too
						this.startLoadingAnimation();
	
						doAJAX( {
							fieldToListenToCode: fieldToListenTo.attributes.optionCode,
							onSuccess: () => {
								// Stop loading animation in all fields
								fieldToListenTo.stopLoadingAnimation();
								fieldToListenTo.customValueField.stopLoadingAnimation();
								this.stopLoadingAnimation();
							}
						} );
					}, 1000 ) );
				}
				
				// Trigger change event in the parent field as the field load
				// But do it only if the parent field isn't listening to another field too
				if ( ! isDefined( fieldToListenTo.attributes.ajax ) ) {
					fieldToListenTo.field.trigger( 'automator:field:change' );
				}
			} );

			// Check if the "Refresh" button exists and add event listener
			if ( this.$ajaxRefreshBtn ) {
				this.$ajaxRefreshBtn.addEventListener( 'click', () => {
					// Show animation in the target field
					this.startLoadingAnimation();

					doAJAX( {
						fieldToListenToCode: this.attributes.optionCode,
						onSuccess: () => {
							// Stop loading animation 
							this.stopLoadingAnimation();
						}
					} );
				} );
			}
		}

		// Check if we have to perform the call on load
		if ( this.attributes.ajax.event === 'on_load' ) {
			// Show animation in the target field
			this.startLoadingAnimation();

			doAJAX( {
				fieldToListenToCode: this.attributes.optionCode,
				onSuccess: () => {
					// Stop loading animation 
					this.stopLoadingAnimation();
				}
			} );

			// Check if the "Refresh" button exists and add event listener
			if ( this.$ajaxRefreshBtn ) {
				this.$ajaxRefreshBtn.addEventListener( 'click', () => {
					// Show animation in the target field
					this.startLoadingAnimation();

					doAJAX( {
						fieldToListenToCode: this.attributes.optionCode,
						onSuccess: () => {
							// Stop loading animation 
							this.stopLoadingAnimation();
						}
					} );
				} );
			}
		} 
	}

	/**
	 * Listen save
	 */
	listenSave() {
		// Get form element
		// eslint-disable-next-line no-unused-vars
		this.formElement.on( 'saved', ( event ) => {
			// Update the fields array
			this.updateAttributesFieldsFromRow();
		} );
	}

	/**
	 * Use fieldRows to update the original attributes.fields
	 * We will use this to render the container again after it was
	 * saved
	 */
	updateAttributesFieldsFromRow() {
		// Create the array where we're going to save the fields data
		const fields = [];

		// Iterate fieldRows
		this.fieldRows.forEach( ( rowFields ) => {
			// Create array to save the row fields
			const row = [];

			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				row.push( fieldInstance.attributes );
			} );

			// Add row
			fields.push( row );
		} );

		// Update fields
		this.attributes.fields = fields;
	}

	/**
	 * Make list of rows sortable
	 */
	makeRowsSortable() {
		// Check if we should make the rows sortable
		if ( this.attributes.canSortRows ) {
			// Make rows sortable
			// Use sortable from the html5sortable library
			sortable( this.formElement.find( '.form-repeater-fields__table-rows' ), {
				forcePlaceholderSize: true,
				handle: '.form-repeater-fields__table-rows-cell--number',
				placeholder: `<tr><td colspan="${ this.fieldRows[ 0 ].length + 2 }">&nbsp;</td></tr>`,
				// eslint-disable-next-line no-unused-vars
				itemSerializer: ( serializedItem, sortableContainer ) => {
					return {
						position: serializedItem.index,
						html: serializedItem.html,
					};
				},
			} );

			// Listen modifications to the rows order
			this.formElement.find( '.form-repeater-fields__table-rows' ).on( 'sortupdate', ( event ) => {
				// Create an array where each element is the index of the row in the old order
				const newOrder = [];

				// Iterate the rows (in their new order)
				$.each( event.detail.destination.items, ( index, row ) => {
					newOrder.push( $( row ).data( 'order' ) );
				} );

				// Change the order of the rows in the FieldRepeater instance
				const newFieldRowsOrder = [];
				newOrder.forEach( ( oldIndex ) => {
					newFieldRowsOrder.push( this.fieldRows[ oldIndex ] );
				} );
				this.fieldRows = newFieldRowsOrder;

				// Render the field agian
				this.reRender();
			} );
		}
	}

	/**
	 * Create and return fields table
	 *
	 * @since  2.0
	 */
	getFieldsTable() {
		// Create variable to save the table
		const $table = $( `
			<div class="form-repeater-fields" data-id="${ this.attributes.optionCode }">
				<table class="form-repeater-fields__table">
					<thead class="form-repeater-fields__table-heading"></thead>
					<tbody class="form-repeater-fields__table-rows"></tbody>
				</table>
				<div class="form-repeater-fields__actions"></div>
			</div>
		` );

		// Create table with the rows
		// Get table headers
		// We will create a table where the name of the column will
		// be the label of the field
		const heading = [];

		// Iterate the original fields object inside attributes (not the Field instances)
		this.attributes.fields.forEach( ( fieldData ) => {
			// Get column title
			const title = isDefined( fieldData.label ) ? fieldData.label : '';

			// Check if the fields under this column are required
			const isRequired = isDefined( fieldData.isRequired ) ? fieldData.isRequired : false;

			// Check if the fields under this column are hidden
			const isHidden = isDefined( fieldData.isHidden ) ? fieldData.isHidden : false;

			// Get the column description
			const description = isDefined( fieldData.description ) ? fieldData.description : '';

			// Add heading column
			heading.push( {
				title: title,
				description: description,
				isRequired: isRequired,
				isHidden: isHidden,
				id: fieldData.optionCode
			} );
		} );

		// Create HTML of the heading
		const $heading = $( `<tr></tr>` );

		// Add the column with for the row number
		$heading.append(
			$(
				`<th class="form-repeater-fields__table-heading-cell form-repeater-fields__table-heading-cell--number">#</th>`
			)
		);

		// Iterate heading columns
		heading.forEach( ( headingColumn ) => {
			// Create column
			const $headingColumn = $( `<th class="form-repeater-fields__table-heading-cell ${ headingColumn.isHidden ? 'form-repeater-fields__table-heading-cell--hidden' : '' }" data-id="${ headingColumn.id }"></th>` );

			// Add the title
			if ( ! isEmpty( headingColumn.title ) ) {
				$headingColumn.append(
					$( `
					<div class="form-repeater-fields__table-heading-cell-title">
						${ headingColumn.title }
						${ headingColumn.isRequired ? '<span class="form-repeater-fields__table-heading-cell-required"></span>' : '' }
					</div>
				` )
				);
			}

			// Add the description
			if ( ! isEmpty( headingColumn.description ) ) {
				$headingColumn.append(
					$( `
					<div class="form-repeater-fields__table-heading-cell-description">
						${ headingColumn.description }
					</div>
				` )
				);
			}

			// Add heading column
			$heading.append( $headingColumn );
		} );

		// Add the column with for the actions
		$heading.append(
			$(
				`<th class="form-repeater-fields__table-heading-cell form-repeater-fields__table-heading-cell--actions"></th>`
			)
		);

		// Append heading
		const $headingContainer = $table.find( '.form-repeater-fields__table-heading' );
		$headingContainer.append( $heading );

		// Create HTML of the rows
		const $rows = $table.find( '.form-repeater-fields__table-rows' );

		// Get number of rows
		const numberOfRows = this.fieldRows.length;

		// Iterate rows of fields
		this.fieldRows.forEach( ( row, index ) => {
			// Create container for the row
			const $row = $( `<tr data-order="${ index }"></tr>` );

			// Add the column with for the row number
			$row.append(
				$(
					`<td class="form-repeater-fields__table-rows-cell form-repeater-fields__table-rows-cell--number">${
						index + 1
					}</td>`
				)
			);

			// Add fields
			row.forEach( ( fieldInstance ) => {
				// Create container
				const $fieldCell = $( `<td class="form-repeater-fields__table-rows-cell ${ fieldInstance.attributes.isHidden ? 'form-repeater-fields__table-rows-cell--hidden' : '' }" data-id="${ fieldInstance.attributes.optionCode }"></td>` );

				// Get field's DOM element
				const $field = fieldInstance.getFormElement();
				// Make sure all the libraries had been initialized
				fieldInstance.initLibraries();

				// Add field container
				$fieldCell.append( $field );

				// Append field cell to the row
				$row.append( $fieldCell );
			} );

			// Add the column for the actions, and add the delete button
			const $actions = $(
				`<td class="form-repeater-fields__table-rows-cell form-repeater-fields__table-rows-cell--actions"></td>`
			);
			$row.append( $actions );

			const fieldAtts = this.getAttributes();

			// Check if the field requires at least on row and if this is the first row
			if ( index != 0 || ( index == 0 && ( ! this.attributes.isRequired || numberOfRows > 1 ) ) ) {
				// Check if there is a custom "Remove row" label. If there is one,
				// use that, otherwise use the default one
				const removeRowLabel = isDefined( this.attributes.removeRowButtonLabel )
					? this.attributes.removeRowButtonLabel
					: UncannyAutomator.i18n.removeRow;

				// Create delete button
				const $removeRowButton = $(
					`<div class="form-repeater-fields__table-rows-cell-remove" uap-tooltip="${ removeRowLabel }"><span></span></div>`
				);

				// Listen clicks to the remove button
				$removeRowButton.on( 'click', () => {
					// Remove the row by index
					this.deleteRow( index );
				} );

				// if hideActions is false, Add Remove row button
				if ( ! fieldAtts.hideActions ) {
					// Add remove button to the actions cell
					$actions.append( $removeRowButton );
				}
			}

			// Add $row to the $rows element
			$rows.append( $row );
		} );

		// Create "Add row" button
		const fieldAtts = this.getAttributes();
		// if hideActions is false, Add Pair button
		if ( ! fieldAtts.hideActions ) {
			const $addRowButton = $( `
				<div class="uap-btn uap-btn--primary uap-btn--small">
					${ UncannyAutomator.i18n.addRow }
				</div>
			` );

			// Check if we have to change label of the button
			if ( isDefined( this.attributes.addRowButtonLabel ) ) {
				$addRowButton.text( this.attributes.addRowButtonLabel );
			}

			// Listen clicks
			$addRowButton.on( 'click', () => {
				// Show loading animation
				$addRowButton.addClass( 'uap-btn--loading' );

				// Add another row
				this.addRow();
			} );

			// Add actions
			const $actionsContainer = $table.find( '.form-repeater-fields__actions' );
			$actionsContainer.append( $addRowButton );
		}
		return $table;
	}

	/**
	 * Get value
	 *
	 * @since  4.9
	 * @return {Array|Object} Array of objects, where the key is the field ID and the value is the field value
	 */
	getValue( options = {} ) {
		options = { ...{
			includeReadOnly: true
		}, ...options }

		// Create object where we're going to save the values
		const value = [];

		// Iterate rows
		this.fieldRows.forEach( ( row ) => {
			// Get the value of the fields
			const fieldsValue = {};

			// Iterate fields
			row.forEach( ( fieldInstance ) => {
				// Check if the field is editable and if we have to include it
				if ( 
					// Check if we should NOT include the values from read-only fields
					! options.includeReadOnly && 
					// If that's the case, check if the field is read-only
					fieldInstance.attributes.isReadOnly && 
					// BUT, even if it's read only, still include if it's the mapping column
					! fieldInstance.isMappingColumn
				) {
					return;
				}

				// Get the field value
				const fieldInstanceValue = fieldInstance.getValue();

				// Add it to the fieldsValue object
				fieldsValue[ fieldInstance.getFieldID() ] = fieldInstanceValue;

				// Check if we have to save the custom value (only for selects)
				if (
					fieldInstance.type == 'select' && 
					fieldInstanceValue == 'automator_custom_value'
				) {
					try {
						// Save the custom value
						fieldsValue[ `${ fieldInstance.getFieldID() }_custom` ] = fieldInstance.getSelectCustomValue();
					} catch ( e ) {
						console.warn( `Couldn't save the custom value` );
					}
				}
			} );

			// Add fields value to the main array
			value.push( fieldsValue );
		} );

		// Return value
		return value;
	}

	/**
	 * Returns the field value
	 * 
	 * @return {String} The field value
	 */
	get value() {
		return this.getValue();
	}

	/**
	 * Returns the value from the meta
	 */
	get valueFromMeta() {
		let value = null;

		// Check if the field has a value and add it
		if ( this.attributes.hasValue ) {
			// Return that value
			value = this.attributes.currentValue;
		} else if ( this.attributes.hasDefaultValue ) {
			// Return the default value
			value = this.attributes.defaultValue;
		}

		return value;
	}

	/**
	 * Set value
	 * 
	 * @param {Array} newRows The new rows that have to be created
	 * @since 4.9
	 */
	setValue( newRows = [] ) {
		// Remove all the current rows
		this.fieldRows = [];

		// Iterate rows
		newRows.forEach( ( row, index ) => {
			this.addRow( row, false);
		} );

		// Render again
		this.reRender();
	}

	/**
	 * Add row
	 *
	 * @since  2.0
	 */
	addRow( fieldsData = {}, reRender = true ) {
		// Create an empty row
		let emptyRow = JSON.parse( JSON.stringify( this.attributes.fields ) );

		// Now iterate the fields
		emptyRow = emptyRow.map( ( fieldObject ) => {
			// Check if there is a default value for this field
			if ( isDefined( fieldsData[ fieldObject.optionCode ] ) ) {
				// And if there is, use that data
				fieldObject.currentValue = fieldsData[ fieldObject.optionCode ];
			}

			// Create field
			const field = new Field( fieldObject.fieldType, { ...fieldObject, ...{
				itemId: this.attributes.itemId
			} } );

			// AJAX: Check if it's the mapping column
			field.isMappingColumn = field.getFieldID() === this.ajaxMappingColumn;

			// Return field instance
			return field;
		} );

		// Add it to the rows of fields
		this.fieldRows.push( emptyRow );

		// Render form element again
		if ( reRender ) {
			this.reRender( true );
		}
	}

	/**
	 * Rerender the field again
	 */
	reRender( focusFirstFieldOfLastRow = false ) {
		// Create all the fields again
		this.fieldRows = this.value.map( ( rowValues ) => {
			// Create an empty row
			let newRow = JSON.parse( JSON.stringify( this.attributes.fields ) );

			// Now iterate the fields
			newRow = newRow.map( ( fieldObject ) => {
				// Create field
				const field = new Field( fieldObject.fieldType, { ...fieldObject, ...{
					currentValue: rowValues[ fieldObject.optionCode ],
					itemId: this.attributes.itemId
				} } );

				// AJAX: Check if it's the mapping column
				field.isMappingColumn = field.getFieldID() === this.ajaxMappingColumn;

				// Return field instance
				return field;
			} );

			return newRow;
		} );

		// Create the form element again
		const $currentFormElement = this.formElement;
		const $newFormElement = this.createFormElement( false );
		$currentFormElement.replaceWith( $newFormElement );

		// Create the date/time selector
		this.initFlatpickr();

		// Create the token selector
		this.initTokenSelector();

		// Create the CodeMirror instances
		this.initCodeMirror();

		// Check if we have to focus the first field of the last row
		if ( focusFirstFieldOfLastRow ) {
			// Get the last row
			const lastRow = this.fieldRows[ this.fieldRows.length - 1 ];

			if ( isDefined( lastRow ) ) {
				// Get the first field
				const firstField = lastRow[ 0 ];

				if ( isDefined( firstField ) ) {
					firstField.focus();
				}
			}
		}
	}

	/**
	 * Delete row
	 *
	 * @since  2.0
	 */
	deleteRow( index ) {
		// Check if there is a row with that index
		if ( isDefined( this.fieldRows[ index ] ) ) {
			// Remove element
			this.fieldRows.splice( index, 1 );
		}

		// Render form element again
		this.formElement.replaceWith( this.createFormElement() );
	}

	/**
	 * Shows an error in the field
	 * 
	 * @param {String} message The message to clear the error
	 */
	setError( message = '' ) {
		// Make sure there is a message defined
		if ( isEmpty( message ) ) {
			return;
		}

		// Add error classes
		this.$errorWrapper.innerHTML = message;

		// Add error class to the main wrapper
		this.formElement.get(0).classList.add( 'form-element--error' );
	}

	/**
	 * Removes the error from a field
	 */
	clearError() {
		// Remove message
		this.$errorWrapper.innerHTML = '';

		// Remove error class (hide error container too)
		this.formElement.get(0).classList.remove( 'form-element--error' );
	}

	/**
	 * Adds loading animation to field
	 *
	 * @since 4.9
	 */
	startLoadingAnimation() {
		// Check if has class
		const CSSclass = 'form-element--loading';

		if ( isDefined( this.formElement ) && ! this.formElement.hasClass( CSSclass ) ) {
			// Add class
			this.formElement.addClass( CSSclass );

			// Trigger
			this.formElement.trigger( 'automator:field:loading' );
		}
	}

	/**
	 * Removes loading animation to field
	 *
	 * @since 4.9
	 */
	stopLoadingAnimation() {
		// Check if has class
		const CSSclass = 'form-element--loading';

		if ( isDefined( this.formElement ) && this.formElement.hasClass( CSSclass ) ) {
			// Remove class
			this.formElement.removeClass( CSSclass );

			// Remove checkbox class
			this.fieldContainer.removeClass( 'form-checkbox--loading-inline' );

			// Trigger
			this.formElement.trigger( 'automator:field:loading' );
		}
	}

	/**
	 * Returns the container that shows the error message
	 */
	get $errorWrapper() {
		return this.formElement.get(0).querySelector( '.form-element__error' );
	}

	/**
	 * Returns button to manually retry AJAX call
	 */
	get $ajaxRefreshBtn() {
		return this.formElement.get(0).querySelector( '.form-element-ajax-refresh-btn' );
	}

	/**
	 * Get form element
	 *
	 * @since 2.0
	 * @return {object} jQuery object of the field's container
	 */
	getFormElement() {
		// Reset the "first load" status
		this.attributes.completedFirstLoad = false;

		// Return form element
		return this.formElement;
	}

	/**
	 * Get attributes
	 *
	 * @since 2.0
	 * @return {object} Field attributes
	 */
	getAttributes() {
		return this.attributes;
	}

	/**
	 * Get field ID
	 *
	 * @since 2.0
	 * @return {string} The field ID
	 */
	getFieldID() {
		return this.attributes.optionCode;
	}

	/**
	 * Validate the fields
	 *
	 * @since 2.0
	 * @param {boolean} renderError - TRUE if you want to render the field errors, FALSE if you only want to return the response object
	 * @return {object} Object where the key is the field ID and the value is a validateField object
	 */
	validate( renderError = true ) {
		// Create validation object
		const validation = {
			isValid: true,
			message: '',
		};

		// Create array to save the validation of the rows
		const rowsValidation = [];

		// Iterate fields
		this.fieldRows.forEach( ( row ) => {
			// Create object to save the row validation
			const rowValidation = {};

			// Iterate each field
			row.forEach( ( fieldInstance ) => {
				// Validate and add response to the validation object
				rowValidation[ fieldInstance.getFieldID() ] = fieldInstance.validate( renderError );

				// Update global validation
				validation.isValid = validation.isValid && rowValidation[ fieldInstance.getFieldID() ].isValid;
			} );

			// Add row validation to the main validation array
			rowsValidation.push( rowValidation );
		} );

		// Return validation object
		return validation;
	}

	initTokenSelector() {
		this.fieldRows.forEach( ( rowFields ) => {
			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				fieldInstance.initTokenSelector();
			} );
		} );
	}

	destroyTokenSelector() {
		this.fieldRows.forEach( ( rowFields ) => {
			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				fieldInstance.destroyTokenSelector();
			} );
		} );
	}

	/**
	 * Create date/time selector
	 */
	initFlatpickr() {
		// Iterate rows
		this.fieldRows.forEach( ( rowFields ) => {
			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				fieldInstance.initFlatpickr();
			} );
		} );
	}

	/**
	 * Destroys the date/time selectors that were created before for
	 * this repeater field
	 */
	destroyFlatpickr() {
		// Iterate rows
		this.fieldRows.forEach( ( rowFields ) => {
			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				fieldInstance.destroyFlatpickr();
			} );
		} );
	}

	initCodeMirror() {
		this.fieldRows.forEach( ( rowFields ) => {
			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				fieldInstance.initCodeMirror();
			} );
		} );
	}

	destroyCodeMirror() {
		this.fieldRows.forEach( ( rowFields ) => {
			// Iterate row fields
			rowFields.forEach( ( fieldInstance ) => {
				// Add field
				fieldInstance.destroyCodeMirror();
			} );
		} );
	}
}

export default FieldsRepeater;
